/**
 * @name handleClientSideSorting
 * @desc Sort data set with set sorter in client side.
 * @param {array} dataSet
 * @param {object} sorter
 * @return data
 */

export default function handleClientSideSorting(dataSet, sorter) {
	const { direction, column, type } = sorter;

	return [...dataSet].sort((a, b) => {
		let compareA = a[column];
		let compareB = b[column];

		if (compareA === "" || compareA === null || compareA === undefined) return 1;
    	if (compareB === "" || compareB === null || compareB === undefined) return -1;

		// if sorter type numeric, convert possible string value to number
		if (type === 'numeric') {
			compareA = Number(compareA);
			compareB = Number(compareB);
		}

		if (direction === 'asc') {
			return (type === 'numeric')
				? compareA - compareB
				: compareA.localeCompare(compareB);
		}

		return (type === 'numeric')
			? compareB - compareA
			: compareB.localeCompare(compareA);
	});
}